import httpUtil from "@/utils/httpUtil";

export const selectShopList = params => httpUtil.get("/crkShop", params);
export const addOrUpdateShop = params => httpUtil.post("/crkShop/add", params);
export const delShop = params => httpUtil.post("/crkShop/delete",params);


